<template>
<b-container fluid="true" v-if="performances" class="pb-50">
    <div class="tab-panel">
        <div class="tab-row">
            <div class="tab" :class="{'active': tab == 0}" @click="tab = 0">
                <div>Analyse globale</div>
            </div>
            <div class="tab" :class="{'active': (tab == 1 || tab == 2)}" @click="tab = 1">
                <div>Analyse de vitesse</div>
            </div>
        </div>
        <div>
            <b-button type="button" v-if="tab === 2" class="panel-video-btn-ui" style="background-color: #A4A4A4">
                <img class="panel-video-img" :src="require('@/assets/img/pageicon/videocamera.png')" /> Revoir
            </b-button>
             <b-button type="button" v-else class="panel-video-btn-ui" @click="tab = 2">
              <img class="panel-video-img" :src="require('@/assets/img/pageicon/videocamera.png')" /> Revoir
            </b-button>
        </div>
    </div>
    <div class="panel-body">
        <b-row v-if="tab != 2" align-h="between">
            <!-- Analyse global -->
            <b-col md="6" class="full-ipad" v-if="tab == 0" style="margin-bottom: 15px" >
                <PropagateLoader v-if="kpiGlobalLoading" class="center-block-high"></PropagateLoader>  
                <div class="tab-1-card" v-if="kpiGlobal">
                    <div class="record-row">
                        <div class="icon-data-row">
                            <div class="icon-img-dist"><img class="dir-img" :src="require('@/assets/img/pageicon/direction1.png')" /> Distance</div>
                            <div class="text-dist">{{ kpiGlobal.distance.total }}</div>
                        </div>
                        <div class="col-3-data-row">
                            <div class="planing-text">{{ overSpeedThresoldLabel }}</div>
                            <div class="planing-km">{{ kpiGlobal.distance.foiling.length }}</div>
                            <div class="planing-km">{{ kpiGlobal.distance.foiling.ratio }} %</div>
                        </div>
                        <div class="col-3-data-row">
                            <div class="planing-text">{{ underSpeedThresoldLabel }}</div>
                            <div class="planing-km">{{ kpiGlobal.distance.nonFoiling.length }}</div>
                            <div class="planing-km">{{ kpiGlobal.distance.nonFoiling.ratio }} %</div>
                        </div>
                    </div>
                    <div class="record-row">
                        <div class="icon-data-row">
                            <div class="icon-img-dist"><img class="dir-img" :src="require('@/assets/img/pageicon/timer.png')" /> Durée</div>
                            <div class="text-dist">{{ durationFormatter(kpiGlobal.duration.total) }}</div>
                        </div>
                        <div class="col-3-data-row">
                            <div class="planing-text">{{ overSpeedThresoldLabel }}</div>
                            <div class="planing-km">{{ durationFormatter(kpiGlobal.duration.foiling.duration) }}</div>
                            <div class="planing-km">{{ kpiGlobal.duration.foiling.ratio }} %</div>
                        </div>
                        <div class="col-3-data-row">
                            <div class="planing-text">{{ underSpeedThresoldLabel }}</div>
                            <div class="planing-km">{{ durationFormatter(kpiGlobal.duration.nonFoiling.duration) }}</div>
                            <div class="planing-km">{{ kpiGlobal.duration.nonFoiling.ratio }} %</div>
                        </div>
                    </div>
                    <div class="record-row">
                        <div class="icon-data-row">
                            <div class="icon-img-dist"><img class="dir-img" :src="require('@/assets/img/pageicon/u-turn-right.png')" /> Virements</div>
                            <div class="text-dist">{{ kpiGlobal.tacks.total }}</div>
                        </div>
                        <div class="col-3-data-row">
                            <div class="planing-text">{{ overSpeedThresoldLabel }}</div>
                            <div class="planing-km">{{ kpiGlobal.tacks.foiling.number }}</div>
                            <div class="planing-km">{{ kpiGlobal.tacks.foiling.ratio }} %</div>
                        </div>
                        <div class="col-3-data-row">
                            <div class="planing-text">{{ underSpeedThresoldLabel }}</div>
                            <div class="planing-km">{{ kpiGlobal.tacks.nonFoiling.number }}</div>
                            <div class="planing-km">{{ kpiGlobal.tacks.nonFoiling.ratio }} %</div>
                        </div>
                        <!-- <div class="col-3-data-row">
                            <div class="planing-text">Missed</div>
                            <div class="planing-km">4</div>
                            <div class="planing-km">18%</div>
                        </div> -->
                    </div>
                    <div class="record-row">
                        <div class="icon-data-row">
                            <div class="icon-img-dist"><img class="dir-img" :src="require('@/assets/img/pageicon/u-turn-left.png')" /> Empanages</div>
                            <div class="text-dist">{{ kpiGlobal.jibes.total }}</div>
                        </div>
                        <div class="col-3-data-row">
                            <div class="planing-text">{{ overSpeedThresoldLabel }}</div>
                            <div class="planing-km">{{ kpiGlobal.jibes.foiling.number }}</div>
                            <div class="planing-km">{{ kpiGlobal.jibes.foiling.ratio }} %</div>
                        </div>
                        <div class="col-3-data-row">
                            <div class="planing-text">{{ underSpeedThresoldLabel }}</div>
                            <div class="planing-km">{{ kpiGlobal.jibes.nonFoiling.number }}</div>
                            <div class="planing-km">{{ kpiGlobal.jibes.nonFoiling.ratio }} %</div>
                        </div>
                        <!-- <div class="col-3-data-row">
                            <div class="planing-text">Missed</div>
                            <div class="planing-km">4</div>
                            <div class="planing-km">18%</div>
                        </div> -->
                    </div>
                    <div class="record-row">
                        <div class="icon-data-row">
                            <div class="icon-img-dist"><img class="dir-img" :src="require('@/assets/img/pageicon/speed-one.png')" /> Vitesse</div>
                        </div>
                        <div class="col-3-data-row">
                            <div class="planing-text">Max</div>
                            <div class="planing-km">{{ kpiGlobal.speed.max }}</div>
                        </div>
                        <div class="col-3-data-row">
                            <div class="planing-text">Moyenne</div>
                            <div class="planing-km">{{ kpiGlobal.speed.mean }}</div>
                        </div>
                        <div class="col-3-data-row">
                            <div class="planing-text">Min</div>
                            <div class="planing-km">{{ kpiGlobal.speed.min }}</div>
                        </div>
                    </div>
                </div>
            </b-col>
            <!-- Analyse de vitesse -->
            <b-col cols="12" md="6" class="full-ipad" v-if="tab == 1" style="margin-bottom: 15px">
                <PropagateLoader v-if="kpiSpeedLoading" class="center-block-high"></PropagateLoader>  
                <div class="tab-2-card" v-if="kpiSpeed">
                    <div class="timer-card-row">
                        <div class="timer-card-col">
                            <div class="timer-card-header" v-b-toggle.collapse-1 role="tab">
                                <div><img class="timer-heder-img" :src="require('@/assets/img/pageicon/timer.png')" /> Durée</div>
                                <div><img class="accordian-img" :src="require('@/assets/img/pageicon/down-arrowacc.png')" /></div>
                            </div>
                            <b-collapse visible id="collapse-1">
                                <div class="timer-card-header-card">
                                    <div class="timer-card-header sub-header">
                                        <img class="timer-heder-img" :src="require('@/assets/img/pageicon/timer.png')" /> 02 s
                                    </div>
                                    <div class="timer-list" v-for="(item,index) in kpiSpeed.duration.best2sec" :key="index">
                                        <div class="timer-list-num">{{ index + 1 }}</div>
                                        <div class="timer-list-val">{{ item.avgSpeed | units('m/s','knot',true) | truncate(2) }}</div>
                                        <v-icon name="eye" v-if="!item.visible" @click="displaySegment('duration','best2sec',index)"></v-icon>
                                        <v-icon name="eye-slash" v-else @click="hideSegment('duration','best2sec',index)"></v-icon>
                                    </div>
                                    <div class="timer-list">
                                        <div class="timer-list-num">Moyenne</div>
                                        <div class="timer-list-val">{{ kpiSpeed.duration.average.best2sec | units('m/s','knot',true) | truncate(2) }}</div>
                                    </div>
                                </div>
                                
                                <div class="timer-card-header-card">
                                    <div class="timer-card-header sub-header">
                                        <img class="timer-heder-img" :src="require('@/assets/img/pageicon/timer.png')" /> 05 s
                                    </div>
                                    <div class="timer-list" v-for="(item,index) in kpiSpeed.duration.best5sec" :key="item.startIdx">
                                        <div class="timer-list-num">{{ index +1 }}</div>
                                        <div class="timer-list-val">{{ item.avgSpeed | units('m/s','knot',true) | truncate(2) }}</div>
                                        <v-icon name="eye" v-if="!item.visible" @click="displaySegment('duration','best5sec',index)"></v-icon>
                                        <v-icon name="eye-slash" v-else @click="hideSegment('duration','best5sec',index)"></v-icon>
                                    </div>
                                    <div class="timer-list">
                                        <div class="timer-list-num">Moyenne</div>
                                        <div class="timer-list-val">{{ kpiSpeed.duration.average.best5sec | units('m/s','knot',true) | truncate(2) }}</div>
                                    </div>
                                </div>
                                                        
                                <div class="timer-card-header-card">
                                    <div class="timer-card-header sub-header">
                                        <img class="timer-heder-img" :src="require('@/assets/img/pageicon/timer.png')" /> 10 s
                                    </div>
                                    <div class="timer-list" v-for="(item,index) in kpiSpeed.duration.best10sec" :key="item.startIdx">
                                        <div class="timer-list-num">{{ index + 1 }}</div>
                                        <div class="timer-list-val">{{ item.avgSpeed | units('m/s','knot',true) | truncate(2) }}</div>
                                        <v-icon name="eye" v-if="!item.visible" @click="displaySegment('duration','best10sec',index)"></v-icon>
                                        <v-icon name="eye-slash" v-else @click="hideSegment('duration','best10sec',index)"></v-icon>
                                    </div>
                                    <div class="timer-list">
                                        <div class="timer-list-num">Moyenne</div>
                                        <div class="timer-list-val">{{ kpiSpeed.duration.average.best10sec | units('m/s','knot',true) | truncate(2) }}</div>
                                    </div>
                                </div>                            
                            </b-collapse>
                        </div>                       
                    </div>
                    <div class="timer-card-row">
                        <div class="timer-card-col">
                            <div class="timer-card-header" v-b-toggle.collapse-2 role="tab">
                                 <div><img class="timer-heder-img" :src="require('@/assets/img/pageicon/timer.png')" /> Distance</div>
                                <div><img class="accordian-img" :src="require('@/assets/img/pageicon/down-arrowacc.png')" /></div>
                            </div>
                            <b-collapse id="collapse-2">

                                <div class="timer-card-header-card">
                                    <div class="timer-card-header sub-header">
                                        <img class="timer-heder-img" :src="require('@/assets/img/pageicon/timer.png')" /> 100m
                                    </div>
                                    <div class="timer-list" v-for="(item,index) in kpiSpeed.distance.best100m" :key="item.startIdx">
                                        <div class="timer-list-num">{{ index + 1 }}</div>
                                        <div class="timer-list-val">{{ item.avgSpeed | units('m/s','knot',true) | truncate(2) }}</div>
                                        <v-icon name="eye" v-if="!item.visible" @click="displaySegment('distance','best100m',index)"></v-icon>
                                        <v-icon name="eye-slash" v-else @click="hideSegment('distance','best100m',index)"></v-icon>
                                    </div>
                                    <div class="timer-list">
                                        <div class="timer-list-num">Moyenne</div>
                                        <div class="timer-list-val">{{ kpiSpeed.distance.average.best100m | units('m/s','knot',true) | truncate(2) }}</div>
                                    </div>
                                </div>
                                
                                <div class="timer-card-header-card">
                                    <div class="timer-card-header sub-header">
                                        <img class="timer-heder-img" :src="require('@/assets/img/pageicon/timer.png')" /> 250m
                                    </div>
                                    <div class="timer-list" v-for="(item,index) in kpiSpeed.distance.best250m" :key="item.startIdx">
                                        <div class="timer-list-num">{{ index + 1 }}</div>
                                        <div class="timer-list-val">{{ item.avgSpeed | units('m/s','knot',true) | truncate(2) }}</div>
                                        <v-icon name="eye" v-if="!item.visible" @click="displaySegment('distance','best250m',index)"></v-icon>
                                        <v-icon name="eye-slash" v-else @click="hideSegment('distance','best250m',index)"></v-icon>
                                    </div>
                                    <div class="timer-list">
                                        <div class="timer-list-num">Moyenne</div>
                                        <div class="timer-list-val">{{ kpiSpeed.distance.average.best250m | units('m/s','knot',true) | truncate(2) }}</div>
                                    </div>
                                </div>
                           
                                <div class="timer-card-header-card">
                                    <div class="timer-card-header sub-header">
                                        <img class="timer-heder-img" :src="require('@/assets/img/pageicon/timer.png')" /> 1500m
                                    </div>
                                    <div class="timer-list" v-for="(item,index) in kpiSpeed.distance.best1500m" :key="item.startIdx">
                                        <div class="timer-list-num">{{ index + 1 }}</div>
                                        <div class="timer-list-val">{{ item.avgSpeed | units('m/s','knot',true) | truncate(2) }}</div>
                                        <v-icon name="eye" v-if="!item.visible" @click="displaySegment('distance','best1500m',index)"></v-icon>
                                        <v-icon name="eye-slash" v-else @click="hideSegment('distance','best1500m',index)"></v-icon>
                                    </div>
                                    <div class="timer-list">
                                        <div class="timer-list-num">Moyenne</div>
                                        <div class="timer-list-val">{{ kpiSpeed.distance.average.best1500m | units('m/s','knot',true) | truncate(2) }}</div>
                                    </div>
                                </div>  

                                <div class="timer-card-header-card">
                                    <div class="timer-card-header sub-header">
                                        <img class="timer-heder-img" :src="require('@/assets/img/pageicon/timer.png')" /> 1 mille
                                    </div>
                                    <div class="timer-list" v-for="(item,index) in kpiSpeed.distance.best1852m" :key="item.startIdx">
                                        <div class="timer-list-num">{{ index + 1 }}</div>
                                        <div class="timer-list-val">{{ item.avgSpeed | units('m/s','knot',true) | truncate(2) }}</div>
                                        <v-icon name="eye" v-if="!item.visible" @click="displaySegment('distance','best1852m',index)"></v-icon>
                                        <v-icon name="eye-slash" v-else @click="hideSegment('distance','best1852m',index)"></v-icon>
                                    </div>
                                    <div class="timer-list">
                                        <div class="timer-list-num">Moyenne</div>
                                        <div class="timer-list-val">{{ kpiSpeed.distance.average.best1852m | units('m/s','knot',true) | truncate(2)}}</div>
                                    </div>
                                </div>                            
                            </b-collapse>
                        </div>  
                    </div>
                </div>
            </b-col>
            <b-col md="6" class="full-ipad" style="margin-bottom: 15px">
                <div class="map-1">
                    <map2d :trackPath="trackPath" :segments="runSegments" class="map-img" />
                </div>
            </b-col>
        </b-row>

        <b-row v-if="tab == 2">
            <b-col cols="12" md="12">
                <div class="map-2">
                    <earth-map :trackPath="trackPath" :motionData="motionData" :sport="performances.sport" :windDirection="performances.meteo.windDirection" ></earth-map>
                </div>
            </b-col>
            <!-- <b-col cols="12" md="12">
                <div class="bottom-play-block">
                    <img class="play-img" :src="require('@/assets/img/pageicon/prev.png')" />
                    <img class="play-img" :src="require('@/assets/img/pageicon/pause.png')" />
                    <img class="play-img" :src="require('@/assets/img/pageicon/play.png')" />
                    <img class="play-img" :src="require('@/assets/img/pageicon/next.png')" />  
                    <div class="map-action">X 32</div>                     
                </div>
            </b-col> -->
        </b-row>
    </div>
</b-container>
</template>

<script>

import EarthMap from '@/components/Maps/EarthMap';

export default {
    data() {
        return {
            tab: 0,
            trackPath:[],
            motionData:[],
            kpiGlobal:null,
            kpiGlobalLoading:false,
            kpiSpeed:null,
            kpiSpeedLoading:false,
            runSegments:[]
        }
    },
    components:{
        EarthMap
    },
    computed: {
        performances() {
            return this.$store.getters['Performances/edit']
        },
        overSpeedThresoldLabel(){
            if(this.performances.sport === "WINDFOIL" || this.performances.sport === "KITEFOIL"){
                return this.$t('performances.main.foiling');
            }else{
                return this.$t('performances.main.planning')
            }
        },
        underSpeedThresoldLabel(){
            if(this.performances.sport === "WINDFOIL" || this.performances.sport === "KITEFOIL"){
                return this.$t('performances.main.nonFoiling');
            }else{
                return this.$t('performances.main.nonPlanning')
            }
        }
    },
    methods: {
        formatKpiGlobal(kpiStandardValues){

            this.kpiGlobal = {       
                distance: {
                    total: this.$units(kpiStandardValues.distance.total).from('m').to('km').toFixed(2) +' '+ this.$units().describe('km').abbr ,
                    foiling: {
                        length: this.$units(kpiStandardValues.distance.foiling.length).from('m').to('km').toFixed(2) +' '+ this.$units().describe('km').abbr,
                        ratio: (kpiStandardValues.distance.foiling.ratio * 100).toFixed(1)
                    },
                    nonFoiling: {
                        length : this.$units(kpiStandardValues.distance.nonFoiling.length).from('m').to('km').toFixed(2) +' '+ this.$units().describe('km').abbr,
                        ratio: (kpiStandardValues.distance.nonFoiling.ratio * 100).toFixed(1)
                    }
                },
                duration: {
                    total: this.$moment.duration(kpiStandardValues.duration.total,'seconds'),
                    foiling: {
                        duration: this.$moment.duration(kpiStandardValues.duration.foiling.duration,'seconds'),
                        ratio: (kpiStandardValues.duration.foiling.ratio * 100).toFixed(1)
                    },
                    nonFoiling: {
                        duration: this.$moment.duration(kpiStandardValues.duration.nonFoiling.duration,'seconds'),
                        ratio: (kpiStandardValues.duration.nonFoiling.ratio * 100).toFixed(1)
                    }
                },
                tacks: {
                    total: kpiStandardValues.tacks.total,
                    foiling: {
                        number: kpiStandardValues.tacks.foiling.number,
                        ratio: (kpiStandardValues.tacks.foiling.ratio * 100).toFixed(1)
                    },
                    nonFoiling: {
                        number: kpiStandardValues.tacks.nonFoiling.number,
                        ratio: (kpiStandardValues.tacks.nonFoiling.ratio * 100).toFixed(1)
                    }
                },
                jibes: {
                    total: kpiStandardValues.jibes.total,
                    foiling: {
                        number: kpiStandardValues.jibes.foiling.number,
                        ratio: (kpiStandardValues.jibes.foiling.ratio * 100).toFixed(1)
                    },
                    nonFoiling: {
                        number: kpiStandardValues.jibes.nonFoiling.number,
                        ratio: (kpiStandardValues.jibes.nonFoiling.ratio * 100).toFixed(1)
                    }
                },
                speed: {
                    max: this.$units(kpiStandardValues.speed.max).from('m/s').to('knot').toFixed(2) +' '+ this.$units().describe('knot').abbr ,
                    min: this.$units(kpiStandardValues.speed.min).from('m/s').to('knot').toFixed(2) +' '+ this.$units().describe('knot').abbr ,
                    mean: this.$units(kpiStandardValues.speed.mean).from('m/s').to('knot').toFixed(2) +' '+ this.$units().describe('knot').abbr 
                }
            };
        },
        formatKpiSpeed(kpiStandardValues){
            this.kpiSpeed = kpiStandardValues;
            this.kpiSpeed.duration.average = {};

            const bestDurations = ['best2sec','best5sec','best10sec'];

            bestDurations.forEach(best => {
                this.kpiSpeed.duration.average[best] = 0;
                this.kpiSpeed.duration[best].forEach((element,idx) => {
                    this.kpiSpeed.duration.average[best] += element.avgSpeed;
                    this.kpiSpeed.duration[best][idx].path = [];
                    for(var id=this.kpiSpeed.duration[best][idx].startIdx;id<this.kpiSpeed.duration[best][idx].endIdx+1;id++){
                        this.kpiSpeed.duration[best][idx].path.push(this.trackPath[id]); 
                    }
                    this.$set(this.kpiSpeed.duration[best][idx], 'visible', false);
                }); 
                this.kpiSpeed.duration.average[best] = this.kpiSpeed.duration.average[best] / this.kpiSpeed.duration[best].length;
            });

            this.kpiSpeed.distance.average = {};
            const bestDistances = ['best100m','best250m','best1500m','best1852m'];

            bestDistances.forEach(best => {
                this.kpiSpeed.distance.average[best] = 0;
                this.kpiSpeed.distance[best].forEach((element,idx) => {
                    this.kpiSpeed.distance.average[best] += element.avgSpeed;
                    this.kpiSpeed.distance[best][idx].path = [];
                    for(var id=this.kpiSpeed.distance[best][idx].startIdx;id<this.kpiSpeed.distance[best][idx].endIdx+1;id++){
                        this.kpiSpeed.distance[best][idx].path.push(this.trackPath[id]); 
                    }
                    this.kpiSpeed.distance[best][idx].visible = false;
                }); 
                this.kpiSpeed.distance.average[best] = this.kpiSpeed.distance.average[best] / this.kpiSpeed.distance[best].length;
            });
        },
        durationFormatter(duration){
            return this.$moment.utc(duration.asMilliseconds()).format('HH:mm:ss');
        },
        displaySegment(kpiType,best,index){
            console.log(`display segment : ${kpiType} - ${best} - ${index}`);
            this.kpiSpeed[kpiType][best][index].visible = true;
            this.runSegments.push({
                color:"blue",
                points:this.kpiSpeed[kpiType][best][index].path
            });
        },
        hideSegment(kpiType,best,index){
            console.log(`hide segment : ${kpiType} - ${best} - ${index}`);
            this.kpiSpeed[kpiType][best][index].visible = false;

            const idxToRemove = this.runSegments.findIndex((segment)=>{ return segment.points === this.kpiSpeed[kpiType][best][index].path; });
            this.runSegments.splice(idxToRemove,1);
        }
    },
    async created() {

        try {
            
            const Id = this.$route.params.Id;

            this.$store.dispatch('Performances/analysis',Id)
                .then(()=>{

                    const AnalysId = Object.keys(this.performances.analysis)[0];
                    
                    if(AnalysId == null){
                        return;
                    }

                    this.$store.dispatch('Performances/analysisData',{per_id:Id,ana_id:AnalysId})
                        .then((data)=>{
                            this.trackPath = data.map(pt => { return [pt.latitude,pt.longitude,pt.speed]; });
                            this.motionData = data;

                            // Load Global
                            this.kpiGlobalLoading = true;
                            this.$store.dispatch('Performances/kpiGlobal',{per_id:Id,ana_id:AnalysId})
                                .then(()=>{
                                    this.formatKpiGlobal(this.performances.analysis[AnalysId].kpi.global);
                                    this.kpiGlobalLoading = false;
                                })
                                .catch((error)=>{
                                    this.kpiGlobalLoading = false;
                                    this.$store.dispatch('error', error);
                                });

                            // Load Speed
                            this.kpiSpeedLoading = true;
                            this.$store.dispatch('Performances/kpiSpeed',{per_id:Id,ana_id:AnalysId})
                                .then(()=>{
                                    this.formatKpiSpeed(this.performances.analysis[AnalysId].kpi.speed);
                                    this.kpiSpeedLoading = false;
                                })
                                .catch((error) => {
                                    this.kpiSpeedLoading = false;
                                    this.$store.dispatch('error', error);
                                });
                        })
                        .catch((error)=>{
                            this.$store.dispatch('error', error);
                        });

                })
                .catch((error)=>{
                    this.$store.dispatch('error',error);
                });
 
        } catch (error) {
            this.$store.dispatch('error', error);
        }  

    }
}
</script>
